
import { defineComponent } from 'vue'
import { directive as tippy } from 'vue-tippy'

export default defineComponent({
    name: 'ToolbarButton',
    directives: {
        tippy
    },
    props: {
        display: {
            type: String,
            required: false,
            default: 'horizontal'
        },
        icon: {
            type: Array,
            required: false,
            default: null
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        selected: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['click', 'mouseDown'],
    setup (props, { emit }) {
        const onClick = () => {
            emit('click')
        }

        const onMouseDown = () => {
            emit('mouseDown')
        }

        return {
            onClick,
            onMouseDown
        }
    }
})
